import $ from 'jquery';

class RoostGallery {

    constructor() {
        this.setupMainSlider();
        this.setupNavSlider();
    }

    events() {
        // none setup here
    }

    setupMainSlider() {
        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: '.slider-nav'
        });

        $('.slider-for').css('display','block');
    }

    setupNavSlider() {
        $('.slider-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            variableWidth: true
        });

        $('.slider-nav').addClass('d-md-block');
    }
}

export default RoostGallery;
